import {load} from '@shopify/theme-sections';
import {formatMoney} from '@shopify/theme-currency';
import '../sections/product';
import 'slick-carousel/slick/slick';
// Use jquery-zoom for product image-zoom effects
require('jquery-zoom');
require('slick-carousel');
load('*');


$('.responsive-image__image').on('load', function() {
  if(window.matchMedia("(min-width: 767px)").matches){
   const reg = /_300x/;
    let url = $(this).attr('src');
    url = url.replace(reg, '');
    $(this).parent('.responsive-image__wrapper').zoom({url});
 }
});
